module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraLight.d8cce1a6.woff2";